/* eslint-disable no-mixed-spaces-and-tabs,no-param-reassign,no-plusplus,@typescript-eslint/no-shadow,no-tabs,@typescript-eslint/no-unused-vars */

xplenty.directive('fileNamesPattern', [
  '$timeout',

  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./file-names-pattern.html'),

      replace: true,

      link(scope, element, attrs) {
        scope.fileNames = [];

        let promise;

        const fileTypes = {
          json_destination_type: '.json',
          parquet_destination_type: '.parquet',
          csv_destination_type: '.csv',
        };

        const compressionTypes = {
          none: '',
          gzip: '.gz',
          bz2: '.bz2',
        };

        let lastSuffix = scope.component.suffix;
        const initFiles = function (newComponent, oldComponent) {
          const typeKeys = Object.keys(newComponent.destination_type);
          if (typeKeys.length === 1 && fileTypes[typeKeys[0]]) {
            const isCustomSuffix = (function () {
              let isCustomSuffix = true;
              _.forIn(fileTypes, function (value, key) {
                if (value + compressionTypes[oldComponent.compression_type] === newComponent.suffix)
                  isCustomSuffix = false;
              });
              return isCustomSuffix;
            })();
            if (!isCustomSuffix || lastSuffix === null) {
              newComponent.suffix = fileTypes[typeKeys[0]];
              if (compressionTypes[newComponent.compression_type]) {
                newComponent.suffix += compressionTypes[newComponent.compression_type];
              }
            }
            lastSuffix = newComponent.suffix;
          }

          const PREVIEW_FILES_COUNT = newComponent && newComponent.enforce_single_file ? 1 : 3;

          $timeout.cancel(promise);
          promise = $timeout(function () {
            scope.fileNames = [];
            for (let i = 0; i < PREVIEW_FILES_COUNT; i++) {
              scope.fileNames.push(`${newComponent.prefix || 'part-m-'}0000${i}${newComponent.suffix}`);
            }
          }, 100);
        };

        scope.$watch('component', initFiles, true);
      },
    };
  },
]);
